module.exports = __webpack_public_path__ + "img/CED_Jackson-Street-Building-Roof-474x318.b27fc183.jpg";